import React from 'react';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined'; 
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'; 
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';  
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined'; 
import PowerOutlinedIcon from '@mui/icons-material/PowerOutlined'; 
import ScrollSnapBox from '../ScrollSnapBox';

const ProcessSteps = () => {
  const steps = [
    {
      id: 1,
      title: 'Cost-Effective & Scalable',
      description: 'By integrating both the solar panel and electrolyser into one module, we reduce costs and complexity. Using additive manufacturing, we aim to lowering manufacturing and installation costs.',
      icon: <SavingsOutlinedIcon sx={{ fontSize: 64, color: '#589197' }} />
    },
    {
      id: 2,
      title: 'Simplified Electrolyser Design',
      description: 'Our compact and simple electrolyser design reduces material costs and maintenance needs, ensuring reliable performance with minimal effort. ',
      icon: <SettingsOutlinedIcon sx={{ fontSize: 64, color: '#589197' }} />
    },
    {
      id: 3,
      title: 'Flexible Production',
      description: 'Additive manufacturing allows for rapid production and customization, reducing material waste and enabling scalable, efficient solutions.',
      icon: <PrecisionManufacturingOutlinedIcon sx={{ fontSize: 64, color: '#589197' }} />
    },
    {
      id: 4,
      title: 'Sustainable Energy',
      description: 'These integrated modules combine solar energy with hydrogen production, offering a self-sustaining, renewable energy solution for various applications—whether for grid support or off-grid use.',
      icon: <WbSunnyOutlinedIcon sx={{ fontSize: 64, color: '#589197' }} />
    },
    {
      id: 5,
      title: 'Energy Independence',
      description: 'With this technology, we enable energy independence by utilizing abundant solar energy to produce hydrogen, making the system ideal for remote or off-grid areas.',
      icon: <PowerOutlinedIcon sx={{ fontSize: 64, color: '#589197' }} />
    }
  ];

  return (
    <ScrollSnapBox>
    {({inView}) => (
    <div className="px-6 sm:px-8 md:px-10 lg:px-20 my-8 sm:my-12 md:my-16 lg:my-20"
      style={{
      opacity: inView ? 1 : 0,
      transform: `translateY(${inView ? '0' : '30px'})`,
      transition: 'all 1000ms ease-out'
    }}>
    <div className="w-full mx-auto py-8 text-center">
    
      <h3 className="text-lg md:text-xl lg:text-2xl font-bold mb-2 md:mb-4 text-theme-blue">
        DISCOVER OUR TECHNOLOGY
      </h3>
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
        Key Advantages
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6 md:gap-8 lg:gap-10">
        {steps.map((step, index) => (
          <div key={step.id} className="flex flex-col items-center w-full">
            {/* Circle with number */}
            <div className="relative mb-4">
              <div className="w-24 h-24 rounded-full flex items-center justify-center">
                {/* Icon placeholder - you can replace with actual icons */}
                <div className="w-12 h-12 bg-white/20">
                  {step.icon}
                </div>
              </div>
              
              {/* Connector line */}
              {/* {index < steps.length - 1 && (
                <div 
                  className="hidden lg:block absolute top-1/2 left-full w-full border-t-2 border-dashed border-gray-300"
                  style={{ 
                    transform: 'translateY(-50%)', 
                    width: 'calc(100% - 30px)',
                    marginLeft: '30px'
                  }}
                >
                </div>
              )} */}
            </div>
            
            {/* Content */}
            <h3 className="flex items-center justify-center h-8 md:h-20 text-base md:text-lg font-bold mb-4 px-4 text-center">{step.title}</h3>
            <p className="space-y-2 md:space-y-4 text-sm md:text-base lg:text-lg text-gray-700 text-left">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
    </div>
    )}
    </ScrollSnapBox>
  );
};

export default ProcessSteps;